import { zonedWallTimeToUtcDate } from './dateTimeUtils';
import { getIANATimezone } from './timezoneUtils';

function zoneOf(student) {
  const raw = String(student?.timezone || '').trim();
  if (!raw) return 'UTC';
  return getIANATimezone(raw) || (raw.includes('/') ? raw : 'UTC');
}

export const INDIA_TZ = 'Asia/Kolkata';

function formatRange(meetingDate, startTime, endTime, timeZone) {
  const start = zonedWallTimeToUtcDate(meetingDate, startTime, INDIA_TZ);
  const end = zonedWallTimeToUtcDate(meetingDate, endTime, INDIA_TZ);
  if (!start) return '';
  const tz = timeZone || 'UTC';
  try {
    const fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: tz,
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZoneName: 'short',
    });
    const text = end && typeof fmt.formatRange === 'function'
      ? fmt.formatRange(start, end)
      : fmt.format(start);
    return text.includes(tz) ? text : `${text} (${tz})`;
  } catch {
    return '';
  }
}

export function previewClocks({ meetingDate, startTime, endTime, students }) {
  if (!meetingDate || !startTime || !endTime) return null;
  const parents = [];
  for (const student of (students || []).filter(Boolean)) {
    const timezone = zoneOf(student);
    const existing = parents.find((row) => row.timezone === timezone);
    if (existing) existing.names.push(student.name);
    else {
      parents.push({
        timezone,
        names: [student.name],
        label: formatRange(meetingDate, startTime, endTime, timezone),
      });
    }
  }
  return {
    india: formatRange(meetingDate, startTime, endTime, INDIA_TZ),
    parents,
  };
}

export function studentLabel(student) {
  if (!student) return '';
  return [student.name, student.displayId, student.country].filter(Boolean).join(' · ');
}

export function suggestTitle(students) {
  const names = (students || []).map((student) => student?.name).filter(Boolean);
  if (!names.length) return '';
  return `PMM — ${names.join(' & ')}`;
}

export function parentLine(student) {
  if (!student) return '';
  const names = [student.fatherName, student.motherName].filter(Boolean).join(' / ');
  return [names, student.phone].filter(Boolean).join(' · ');
}
